import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Navbar from "../../components/common/Navbar";
import Footer from "../../components/common/Footer";

const BuySellBusinessServices = () => {
  return (
    <main>

      <Helmet>
        <title>
          Business for Sale in India | Buy Running Business Easily
        </title>

        <meta
          name="description"
          content="Buy or sell profitable businesses in India with trusted business brokerage and business support services."
        />

        <meta
          name="keywords"
          content="business for sale in india,buy running business,profitable business for sale,business brokerage services,sell my business online"
        />

        <link
          rel="canonical"
          href="https://www.businessmateworkflow.in/business-for-sale-buy"
        />

        <meta
          property="og:title"
          content="Buy & Sell Business Services"
        />

        <meta
          property="og:description"
          content="Buy or sell businesses with confidence on our transparent business marketplace platform."
        />

        <meta
          property="og:image"
          content="https://www.businessmateworkflow.in/uploads/profile-photos/profile-1760205836983-728514065.jpg"
        />

        <meta
          property="og:url"
          content="https://www.businessmateworkflow.in/business-for-sale-buy"
        />

      </Helmet>

      <Navbar />

      {/* HERO SECTION */}
      <section
        style={{
          background:
            "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
          padding: "40px 0",
          color: "#fff",
        }}
      >
        <div className="container">
          <div className="row align-items-center">

            {/* LEFT CONTENT */}
            <div className="col-lg-6">

              <span
                style={{
                  background: "#06b590",
                  padding: "8px 18px",
                  borderRadius: "30px",
                  fontSize: "14px",
                  fontWeight: "600",
                  display: "inline-block",
                  marginBottom: "20px",
                }}
              >
                Business Marketplace Solution
              </span>

              <h1
                style={{
                  fontSize: "52px",
                  fontWeight: "800",
                  lineHeight: "1.2",
                  marginBottom: "25px",
                  color: "#fff",
                }}
              >
                Buy & Sell Businesses with Confidence
              </h1>

              <p
                style={{
                  fontSize: "17px",
                  lineHeight: "2",
                  color: "#cbd5e1",
                }}
              >
                Buying or selling a business is a major decision that requires transparency, trust, and proper opportunities. Many entrepreneurs and investors look for profitable businesses, franchise opportunities, or startup collaborations but struggle to find a structured and reliable platform.
              </p>

              <p
                style={{
                  fontSize: "17px",
                  lineHeight: "2",
                  color: "#cbd5e1",
                  marginTop: "15px",
                }}
              >
                At BusinessMateWorkflow™, we provide a business marketplace where buyers and sellers can connect directly and explore genuine business opportunities.
              </p>

            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-6 text-center mt-5 mt-lg-0">

              <img
                src="/uploads/profile-photos/profile-1760205836983-728514065.jpg"
                alt="Buy and Sell Business Services"
                className="img-fluid"
                loading="lazy"
                style={{
                  borderRadius: "25px",
                  boxShadow: "0 25px 60px rgba(0,0,0,0.35)",
                  maxHeight: "550px",
                  objectFit: "cover",
                }}
              />

            </div>

          </div>
        </div>
      </section>

      {/* BUSINESS MARKETPLACE SECTION */}
      <section
        style={{
          padding: "100px 0",
          background: "#f8fafc",
        }}
      >
        <div className="container">

          <div className="text-center mb-5">
            <h2
              style={{
                fontSize: "42px",
                fontWeight: "800",
                marginBottom: "20px",
              }}
            >
              Our Business Marketplace Includes
            </h2>
          </div>

          <div className="row g-4">

            <div className="col-lg-4 col-md-6">
              <div
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "20px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "40px", marginBottom: "15px" }}>🏪</div>
                <h3 style={{ fontWeight: "700", fontSize: "18px", marginBottom: "0" }}>
                  Running businesses for sale
                </h3>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "20px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "40px", marginBottom: "15px" }}>🤝</div>
                <h3 style={{ fontWeight: "700", fontSize: "18px", marginBottom: "0" }}>
                  Startup collaboration opportunities
                </h3>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "20px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "40px", marginBottom: "15px" }}>📜</div>
                <h3 style={{ fontWeight: "700", fontSize: "18px", marginBottom: "0" }}>
                  Franchise opportunities
                </h3>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "20px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "40px", marginBottom: "15px" }}>💰</div>
                <h3 style={{ fontWeight: "700", fontSize: "18px", marginBottom: "0" }}>
                  Business investment opportunities
                </h3>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "20px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "40px", marginBottom: "15px" }}>🔗</div>
                <h3 style={{ fontWeight: "700", fontSize: "18px", marginBottom: "0" }}>
                  Buyer and seller connections
                </h3>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* BENEFITS SECTION */}
      <section
        style={{
          padding: "100px 0",
          background: "#fff",
        }}
      >
        <div className="container">

          <div className="row align-items-center">
            <div className="col-lg-6">
              <h2
                style={{
                  fontSize: "42px",
                  fontWeight: "800",
                  marginBottom: "25px",
                }}
              >
                Benefits of Our Platform
              </h2>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                }}
              >
                <li className="mb-3" style={{ fontSize: "18px", color: "#475569" }}>
                  ✅ Transparent business listings
                </li>
                <li className="mb-3" style={{ fontSize: "18px", color: "#475569" }}>
                  ✅ Easy buyer-seller connections
                </li>
                <li className="mb-3" style={{ fontSize: "18px", color: "#475569" }}>
                  ✅ Access to business opportunities
                </li>
                <li className="mb-3" style={{ fontSize: "18px", color: "#475569" }}>
                  ✅ Organized business marketplace
                </li>
                <li className="mb-3" style={{ fontSize: "18px", color: "#475569" }}>
                  ✅ Faster business expansion opportunities
                </li>
              </ul>

              <div
                style={{
                  background: "#f8fafc",
                  padding: "20px",
                  borderRadius: "15px",
                  marginTop: "25px",
                  borderLeft: "4px solid #06b590",
                }}
              >
                <p style={{ fontSize: "16px", color: "#475569", margin: 0 }}>
                  💡 Entrepreneurs looking for collaboration or investment opportunities can also explore our Business Partner Services to connect with suitable business partners and investors.
                </p>
              </div>
            </div>

            <div className="col-lg-6 mt-5 mt-lg-0">
              <div
                style={{
                  background: "linear-gradient(135deg, #06b590 0%, #059669 100%)",
                  padding: "40px",
                  borderRadius: "25px",
                  color: "#fff",
                  textAlign: "center",
                }}
              >
                <div style={{ fontSize: "60px", marginBottom: "20px" }}>🏆</div>
                <h3 style={{ fontSize: "28px", fontWeight: "700", marginBottom: "15px" }}>
                  Why Choose Our Business Marketplace?
                </h3>
                <p style={{ fontSize: "17px", lineHeight: "1.8", opacity: "0.95" }}>
                  We focus on creating a professional ecosystem where businesses, investors, and entrepreneurs can explore opportunities safely and efficiently. Our goal is to simplify the process of buying, selling, and expanding businesses through structured networking and visibility.
                </p>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* CTA SECTION */}
      <section
        style={{
          background:
            "linear-gradient(135deg, #06b590 0%, #059669 100%)",
          padding: "90px 0",
          textAlign: "center",
          color: "#fff",
        }}
      >
        <div className="container">

          <h2
            style={{
              fontSize: "48px",
              fontWeight: "800",
              marginBottom: "20px",
            }}
          >
            Start Your Business Journey Today
          </h2>

          <p
            style={{
              maxWidth: "800px",
              margin: "0 auto",
              fontSize: "18px",
              lineHeight: "1.9",
              marginBottom: "35px",
            }}
          >
            If you are looking for business opportunities, partnerships, employees, or professional services, you can contact us. Our team will understand your requirement and connect you with the right solution.
          </p>

          <Link to="/contact">
            <button
              className="btn"
              style={{
                background: "#fff",
                color: "#06b590",
                padding: "15px 40px",
                borderRadius: "12px",
                fontWeight: "700",
                border: "none",
                fontSize: "18px",
              }}
            >
              Get Started Now
            </button>
          </Link>

        </div>
      </section>

      <Footer />

    </main>
  );
};

export default BuySellBusinessServices;